module.exports = __webpack_public_path__ + "assets/creditcard-891171.svg";